import React from "react";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    SelectionCard,
    Wrapper,
    ActionSection,
    ScrollableContent,
    FieldWrappers,
    ModalHeader,
    ModalTitle,
} from "../Styles/InputStyles";
import { extraChargeOptions } from "../../utilities/extraChargeConfig";

const EditExtraCharges = ({
    handleClose,
    editExtraChargesLoading,
    editExtraChargesMutate,
    selectedData,
}) => {

    const initialValues = {
        type: selectedData.type,
        chargesType: selectedData.electricityChargesType ?? 1,
        unit: "",
        amount: selectedData.amount.toString(),
        repetition: selectedData.repetitionType,
    };

    const repetition = [
        { value: 1, label: "One Time" },
        { value: 2, label: "Monthly" },
    ];

    // const typeOptions = [
    //     { value: 4, label: "Electricity" },
    //     { value: 5, label: "Registration" },
    //     { value: 6, label: "Tech Charges" },
    //     { value: 3, label: "Maintenance" },
    //     { value: 8, label: "Agreement Charge" },
    //     { value: 9, label: "Food" },
    //     { value: 7, label: "Other" },
    //     { value: 19, label: "Move Out Charges" },
    //     { value: 17, label: "Laundry Charges" },
    //     { value: 14, label: "Maid Charges" },
    //     { value: 12, label: "WiFi Charges" },
    // ];

    const chargesTypeOptions = [
        { value: 1, label: "Amount" },
        { value: 2, label: "Unit" },
    ];

    const handleSubmit = (values, { setSubmitting, resetForm }) => {

        if (!values.type) {
            toast.error("Type is required");
            setSubmitting(false);
            return;
        }

        if (values.type === 4 && !values.chargesType) {
            toast.error("Charges Type is required");
            setSubmitting(false);
            return;
        }

        // Decimal validation allow
        if (values.amount && !/^\d*\.?\d*$/.test(values.amount)) {
            toast.error("Amount must be a valid number");
            setSubmitting(false);
            return;
        }

        const amountValue = Number(values.amount);

        // Common check for empty/zero
        // if (!amountValue || amountValue <= 0) {
        //     toast.error("Amount must be greater than 0");
        //     setSubmitting(false);
        //     return;
        // }

        // Amount type rule (1 to 10,00,000)
        if (values.chargesType !== 1) {
            if (amountValue < 1 || amountValue > 1000000) {
                toast.error("Amount must be between 1 and 10,00,000");
                setSubmitting(false);
                return;
            }
        }

        // Unit type rule (0.1 to 100)
        if (values.chargesType === 2) {
            if (amountValue < 0.1 || amountValue > 100) {
                toast.error("Price per unit must be between 0.1 and 100");
                setSubmitting(false);
                return;
            }
        }

        if (!values.repetition) {
            toast.error("Repetition is required");
            setSubmitting(false);
            return;
        }

        editExtraChargesMutate({
            repetitionType: values.repetition,
            amount: amountValue,
            id: selectedData.id
        });

        setSubmitting(false);
        resetForm();
    };

    return (
        <Container>
            <ModalHeader>
                <ModalTitle>Edit Extra Charges</ModalTitle>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, setFieldValue, handleBlur }) => (
                        <Form>
                            <ScrollableContent>
                                <Wrapper>
                                    {/* TYPE DISPLAY ONLY */}
                                    <InputGroup>
                                        <Label>Type *</Label>
                                        <FieldWrappers className="bg-gray-100">
                                            <Field
                                                name="type"
                                                readOnly
                                                className="w-full truncate "
                                                value={extraChargeOptions.find((opt) => opt.value === values.type)?.label}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    {/* Electricity Only Field */}
                                    {values.type === 4 && (
                                        <InputGroup>
                                            <Label>Charges Type *</Label>
                                            <CardWrapper>
                                                {chargesTypeOptions.map((mode) => (
                                                    <SelectionCard
                                                        key={mode.value}
                                                        type="button"
                                                        onClick={() => {
                                                            setFieldValue("chargesType", mode.value);
                                                            setFieldValue("amount", "");
                                                        }}
                                                        className={
                                                            values.chargesType === mode.value
                                                                ? "bg-[#0078BD] text-white"
                                                                : "bg-gray-100"
                                                        }
                                                    >
                                                        {mode.label}
                                                    </SelectionCard>
                                                ))}
                                            </CardWrapper>
                                        </InputGroup>
                                    )}

                                    {/* AMOUNT / PRICE INPUT */}
                                    {(values.type !== 4 || values.chargesType === 2) && (
                                        <InputGroup>
                                            <Label>
                                                {values.type === 4 && values.chargesType === 2 ?
                                                    "Price per unit *" : "Amount *"}
                                            </Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="text"
                                                    name="amount"
                                                    className="w-full truncate"
                                                    value={values.amount}
                                                    onChange={(e) => {
                                                        const v = e.target.value;
                                                        if (/^\d*\.?\d*$/.test(v)) {
                                                            setFieldValue("amount", v);
                                                        }
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                    )}

                                    {/* REPETITION */}
                                    <InputGroup>
                                        <Label>Repetition *</Label>
                                        <CardWrapper>
                                            {repetition.map((mode) => {
                                                const isDisabled =
                                                    (
                                                        (values.type === 4) &&
                                                        mode.value === 1
                                                    ) ||
                                                    (
                                                        (values.type === 5 || values.type === 8 || values.type === 19) &&
                                                        mode.value === 2
                                                    );

                                                return (
                                                    <SelectionCard
                                                        key={mode.value}
                                                        type="button"
                                                        onClick={() => {
                                                            if (!isDisabled) setFieldValue("repetition", mode.value);
                                                        }}
                                                        className={
                                                            values.repetition === mode.value
                                                                ? "bg-[#0078BD] text-white"
                                                                : isDisabled
                                                                    ? "bg-gray-200 cursor-not-allowed"
                                                                    : "bg-gray-100"
                                                        }
                                                    >
                                                        {mode.label}
                                                    </SelectionCard>
                                                );
                                            })}
                                        </CardWrapper>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>

                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={editExtraChargesLoading}>
                                    {editExtraChargesLoading ? "Processing..." : "Edit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

/* Styled Components */
const CardWrapper = tw.div`flex flex-wrap gap-2 my-1.5`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;

export default EditExtraCharges;
